/** No-op transport. Useful in tests and standalone-anonymous mode. */
export class NullTransport {
    async send(_event) {
        // intentionally empty
    }
}
/**
 * Collects every event sent into an in-memory array, for tests and debugging.
 * Cheap, synchronous, and safe to inspect immediately after `await transport.send(...)`.
 */
export class MemoryTransport {
    sent = [];
    async send(event) {
        this.sent.push(event);
    }
    /** Return every recorded event of a given kind, narrowed to that variant. */
    ofKind(kind) {
        return this.sent.filter((e) => e.kind === kind);
    }
    clear() {
        this.sent.length = 0;
    }
}
//# sourceMappingURL=transport.js.map